import React from "react";
import { getIcon } from "../lib/iconMap";

export default function IngredientCard({ label, selected, onClick, testId }) {
  const Icon = getIcon(label);
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`sc-card ${selected ? "selected" : ""} flex flex-col items-center justify-center p-4 md:p-5 text-center cursor-pointer`}
      style={{ minHeight: "120px" }}
    >
      <Icon
        size={28}
        strokeWidth={1.4}
        className="sc-icon mb-2"
        style={{ color: selected ? "#2C2A28" : "#9CAF88" }}
      />
      <span
        className="text-xs md:text-sm font-medium leading-tight"
        style={{ fontFamily: "Manrope, sans-serif", color: selected ? "#2C2A28" : "#2C2A28" }}
      >
        {label}
      </span>
    </button>
  );
}
